<ng-container *ngIf="layoutSchema">
    <!-- box type -->
    <div *ngIf="layoutSchema.type === 'box'" [ngClass]="layoutSchema.classes ? layoutSchema.classes : []"
        [ngStyle]="layoutSchema.styles ? layoutSchema.styles : {}"
        [attr.id]="layoutSchema.id ? layoutSchema.id : undefined">
        <!-- show layouts -->
        <ng-container *ngIf="layoutSchema.layouts">
            <strong-layout-builder *ngFor="let lay of layoutSchema.layouts" [form]="form"
                (layoutLoadedEvent)="childLayoutLoaded(lay['_id'])" [layout]="lay">
            </strong-layout-builder>
        </ng-container>
        <!-- show text -->
        <ng-container *ngIf="layoutSchema.text">{{layoutSchema.text}}</ng-container>
        <!-- show html -->
        <div *ngIf="layoutSchema.html" [innerHtml]="layoutSchema.html"></div>

        <!-- show widgets -->
        <ng-container *ngIf="layoutSchema.widgets">
            <ng-container #WidgetsSection></ng-container>


        </ng-container>


    </div>
    <!-- grid type -->
    <div *ngIf="layoutSchema.type === 'grid'" [ngClass]="layoutSchema.classes ? layoutSchema.classes : []"
        [ngStyle]="layoutSchema.styles ? layoutSchema.styles : {}"
        [attr.id]="layoutSchema.id ? layoutSchema.id : undefined">
        <!-- show layouts -->
        <ng-container *ngIf="layoutSchema.layouts">
            <strong-layout-builder *ngFor="let lay of layoutSchema.layouts; let i = index"
                (layoutLoadedEvent)="childLayoutLoaded(lay['_id'])" [form]="form" [layout]="lay"
                [ngClass]="layoutSchema['layoutClasses'][i]">
            </strong-layout-builder>
        </ng-container>
    </div>
</ng-container>



<!-- <ng-template #name>


</ng-template> -->